import UpdateResourcePropertyPlugin from './UpdateResourcePropertyPlugin'
import { updateFeatureFlagsPlugin } from '@ahaslides-product/frontend-toolkit'

const kvSyncPlugins = [
  UpdateResourcePropertyPlugin,
  updateFeatureFlagsPlugin,
]

export default kvSyncPlugins
